import { render, staticRenderFns } from "./ReviewsFilterList.vue?vue&type=template&id=a3ea29c4&"
import script from "./ReviewsFilterList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ReviewsFilterList.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3ea29c4')) {
      api.createRecord('a3ea29c4', component.options)
    } else {
      api.reload('a3ea29c4', component.options)
    }
    module.hot.accept("./ReviewsFilterList.vue?vue&type=template&id=a3ea29c4&", function () {
      api.rerender('a3ea29c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/ReviewsFilter/components/ReviewsFilterList.vue"
export default component.exports